function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import Icon from './Icon';
const AlertInformationIcon = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Icon, _extends({
  "data-testid": "alertInformation",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12,21.75A9.75,9.75,0,1,1,21.75,12,9.76,9.76,0,0,1,12,21.75Zm0-18A8.25,8.25,0,1,0,20.25,12,8.26,8.26,0,0,0,12,3.75ZM12.75,17V12a.75.75,0,0,0-1.5,0v5a.75.75,0,0,0,1.5,0ZM12,6.75A1.25,1.25,0,1,0,13.25,8,1.25,1.25,0,0,0,12,6.75Z"
})));
AlertInformationIcon.displayName = 'AlertInformationIcon';
AlertInformationIcon.renderIcon = props => /*#__PURE__*/React.createElement(AlertInformationIcon, props);
export default AlertInformationIcon;
//# sourceMappingURL=AlertInformationIcon.js.map